export { default } from "./TeamsMspa";
